module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_inside_02.f98991a4.jpg";